export const PLATFORM_USERS_QUERY_KEY = 'platformUsers';
